<div [formGroup]="emailForm">
  <div class="input-form-box">
    <h1 class="label">{{ 'FORM.LABELS.EMAIL' | translate}}*</h1>
    <div class="input-box">
      <input
        [ngStyle]="{'border': (submitted && emailControl?.invalid) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
        autocomplete="off"
        autocapitalize="off"
        autocorrect="off"
        formControlName="email"
        placeholder="{{ 'FORM.PLACEHOLDER.EMAIL' | translate}}"
      />
    </div>
    <span
      *ngIf="submitted && emailControl?.hasError('required')"
      class="error-message"
    >
      {{'FORM.VALID.EMAIL_VALID' | translate}}
    </span>
    <span
      *ngIf="submitted && emailControl?.hasError('email')"
      class="error-message"
    >
      {{'FORM.VALID.EMAIL_FORMAT_VALID' | translate}}
    </span>
    <span
      *ngIf="externalError"
      class="error-message"
    >
      {{ externalError }}
    </span>
  </div>
</div>
